export enum ExpenditureSourceTypeEnum {
    bank = 'bank',
    nonBank = 'nonbank',
    country = 'state',
    other = 'other',
}
